import React from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, maxWidth = "max-w-xl" }) {
  React.useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose && onClose(); };
    if (open) {
      document.addEventListener("keydown", onKey);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative w-full ${maxWidth} max-h-[92vh] overflow-y-auto bg-[#0b1324] border border-white/10 rounded-t-3xl sm:rounded-2xl shadow-2xl`}
        role="dialog" aria-modal="true">
        <div className="sticky top-0 flex items-center justify-between gap-3 px-5 py-4 bg-[#0b1324]/95 border-b border-white/10 backdrop-blur">
          <h3 className="font-serif-display text-white text-xl">{title}</h3>
          <button type="button" onClick={onClose} aria-label="close"
            className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-slate-300 hover:text-white hover:bg-white/10">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
